import type { SortByItem } from 'instantsearch.js/es/connectors/sort-by/connectSortBy';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import type {
  AlgoliaCardIndexesName,
  GallerySortName,
  PrintablePlayerSortName,
} from '#src/contexts/config/index.ts';
import { useConfigContext } from '#src/contexts/config/index.ts';
import { sorts as sortsMessages } from '#src/lib/glossary.ts';

import { useIsSorareSearchClient } from './useSearchClient.ts';

export const useI18nSortByItems = (
  sorts: (AlgoliaCardIndexesName | GallerySortName | PrintablePlayerSortName)[]
): (SortByItem & {
  index: AlgoliaCardIndexesName | GallerySortName | PrintablePlayerSortName;
})[] => {
  const { algoliaCardIndexes } = useConfigContext();
  const isSorareSearchClient = useIsSorareSearchClient();
  const { formatMessage } = useIntl();

  return useMemo(
    () =>
      sorts.map(sort => {
        if (!isSorareSearchClient && sort in algoliaCardIndexes) {
          return {
            index: sort,
            value: algoliaCardIndexes[sort as AlgoliaCardIndexesName],
            label:
              (sort in sortsMessages &&
                formatMessage(
                  sortsMessages[sort as keyof typeof sortsMessages]
                )) ||
              sort,
          };
        }

        return {
          index: sort,
          value: sort,
          label:
            (sort in sortsMessages &&
              formatMessage(
                sortsMessages[sort as keyof typeof sortsMessages]
              )) ||
            sort,
        };
      }),
    [algoliaCardIndexes, formatMessage, sorts, isSorareSearchClient]
  );
};
